import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';

export interface IVHSContainerProps extends IBaseElementProps {
	/**
	 * Style
	 */
	style: 'default' | 'lead' | 'wide' | 'single';
	/**
	 * Background
	 */
	background: 'default' | 'swirl';
	children?: any;
	textAlign?: 'left' | 'center' | 'right';
	smallTextColor?: string;
}

/**
 * Container
 * @block
 * @icon shortcode
 */
const VHSContainer: React.FC<IVHSContainerProps> = ({
	style,
	background,
	children,
	textAlign,
	smallTextColor,
	classNames = [],
}) => {
	return (
		<div
			className={cn(
				'vhs-container',
				style === 'lead' && 'vhs-container--lead',
				style === 'wide' && 'vhs-container--wide',
				style === 'single' && 'vhs-container--single',
				background === 'swirl' && 'vhs-container--swirl',
				smallTextColor ? smallTextColor : '',
				...classNames,
			)}
			style={{ textAlign: textAlign }}
		>
			{children}
		</div>
	);
};

export default VHSContainer;
